<template>
  <div class="authority_users">
    <FunctionTitle :title= "mainTitle"/>
		<CommonFlame :title="`${authority_name}を持つ社員一覧`">
      <template v-if="!$vuetify.breakpoint.xs && authority_flag" v-slot:app-bar-btn>
        <AuthorityUserFormDialog :authority_id="id" :company_users="users" @reload="fetchAuthorityUsers(pagination.current)"/>
      </template>     
      <v-container >
        <div class="table-container mt-4">
          <v-data-table
            locale="ja-JP"
            :headers="headers"
            :items="authority_users"
            :mobile-breakpoint="240"
            hide-default-footer
            disable-filtering
            disable-pagination
            disable-sort
            no-data-text="データがありません。"
          >
          <template v-slot:item="{ item }" @reload="fetchAuthoriyUsers()">
              <tr>
                <td>{{ item.user_info.employee_number }}</td>
                <td>{{ item.full_name}}</td>
                <td>{{ item.position}}</td>
                <td>
                  <template v-if="authority_flag">
                    <TemplateDeleteDialog onlyIcon ref=“deleteDialog”>
                      <template v-slot:button>
                        <v-btn class="ma-1" @click="deleteAuthorityUser(item.id)" dense dark color="red"> 削除する </v-btn>
                      </template>
                    </TemplateDeleteDialog>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
      </v-container>
    </CommonFlame> 
  </div>
</template>

<script>
import axios from 'axios';
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import AuthorityUserFormDialog from "./components/AuthorityUserFormDialog.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

  export default {
    components: {
      CommonFlame,
      FunctionTitle,
		  PaginationModule,
      TemplateDeleteDialog,
      AuthorityUserFormDialog,
	  },
    data() {
      return {
        id: this.$route.params["id"],
        mainTitle: "ユーザー権限設定",
        headers: [
				{ text: "社員番号",value: "user_info.employee_number", width:"150px"},
				{ text: "社員名", value: "full_name", width:"250px" },
				{ text: "役職", value: "position", width:"150px" },
        { text: "", value: "", width:"50px"},
			],
        authority_users: [],
        pagination: {
				  count: null,
				  current: 1,
				  limit_value: null,
				  next: null,
				  pages: null,
				  previous: null,
			  },
        authority_flag: false,
        authority_name: "",
		  }
    },
    created() {
      const page = this.$route.query.page ? this.$route.query.page : 1
      this.fetchAuthorityUsers(page)
    }, 

    methods: {
      fetchAuthorityUsers(page){
      authenticate.authenticateUser();
      const headers = authenticate.setHeader();
      axios
				.get(`/erp/v1/authorities/${this.id}/authority_users`, { params: {page: page}, headers})
				.then((res) => {
          this.authority_users = res.data.authority_users
          this.pagination = res.data.pagination
          this.authority_flag = res.data.authority_flag
          this.users = res.data.users
          this.authority_name = res.data.authority.name
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
      },
      getPage(page) {
			  this.fetchAuthorityUsers(page)
		  },

      deleteAuthorityUser(id) {
        const headers = authenticate.setHeader();
        const delete_id = id
        axios
          .delete(`/erp/v1/authorities/${this.id}/authority_users/${delete_id}`, { headers })
          .then((res) => {
            this.$router.go({path: this.$router.currentRoute.path})
            this.$store.commit("setFlash", {
            text: "削除しました",
            type: "notice",
          });

          })
          .catch((err) => {
            errorHandling.errorResponse(err);
          });
        }
    },
  }
</script>